var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var CarouselController = /** @class */ (function (_super) {
    __extends(CarouselController, _super);
    function CarouselController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CarouselController.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "c-carousel__controller" },
            React.createElement("div", { className: "c-carousel__controller__action c-carousel__controller__action--previous" + (!this.isPreviousAvailable() ? ' c-carousel__controller__action--disabled' : ''), onClick: function () { return _this.previous(); } },
                React.createElement("i", { className: "icon-left" })),
            React.createElement("div", { className: "c-carousel__controller__action c-carousel__controller__action--next" + (!this.isNextAvailable() ? ' c-carousel__controller__action--disabled' : ''), onClick: function () { return _this.next(); } },
                React.createElement("i", { className: "icon-right" }))));
    };
    CarouselController.prototype.next = function () {
        if (!this.isNextAvailable()) {
            return;
        }
        if (!this.props.items) {
            return;
        }
        var currentPosition = this.getCurrentPosition();
        if (null === currentPosition) {
            return;
        }
        this.props.updateActiveItem(this.props.items[(currentPosition + 1)]);
    };
    CarouselController.prototype.previous = function () {
        if (!this.isPreviousAvailable()) {
            return;
        }
        if (!this.props.items) {
            return;
        }
        var currentPosition = this.getCurrentPosition();
        if (null === currentPosition || currentPosition <= 0) {
            return;
        }
        this.props.updateActiveItem(this.props.items[(currentPosition - 1)]);
    };
    CarouselController.prototype.isNextAvailable = function () {
        var currentPosition = this.getCurrentPosition();
        if (null === currentPosition || !this.props.items) {
            return false;
        }
        return currentPosition < this.props.items.length - 1;
    };
    CarouselController.prototype.isPreviousAvailable = function () {
        var currentPosition = this.getCurrentPosition();
        return currentPosition && currentPosition > 0;
    };
    CarouselController.prototype.getCurrentPosition = function () {
        if (!this.props.items || null === this.props.activeItemId) {
            return null;
        }
        var itemIds = this.props.items.map(function (item) { return item.id; });
        return itemIds.indexOf(this.props.activeItemId);
    };
    return CarouselController;
}(React.Component));
export default CarouselController;
